/* eslint-disable jsx-a11y/anchor-is-valid */
//import React from "react";
import React, { useState } from "react";
import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faLinkedinIn,
  faInstagram,
  faTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  const [review, setReview] = useState(""); // Store user input
  const [message, setMessage] = useState(""); // Success/Error message
const handleSubmit = async (e) => {
  e.preventDefault();
setMessage("⏳ Submitting your review..."); 
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/reviews`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ comment: review }),
    });

    if (response.ok) {
      setMessage("✅ Review submitted successfully!");
      setReview("");
    } else {
      setMessage("❌ Error submitting review. Try again.");
    }
  } catch (error) {
    console.error("Fetch Error:", error);
    setMessage("⚠️ Server error. Please try again later.");
  }
};

 
  return (
    <footer className="footer">
      <div className="footer-top section" id="footer_section">
        <div className="container grid-list">
          <div className="footer-brand">
            <a href="#" className="logo">
              <img
                src="/logovin.jpg"
                width="162"
                height="50"
                alt="VIN-Together-Logo"
              />
            </a>
            <p className="footer-brand-text">
              For more queries and suggestions feel free to reach us using the
              following details!!
            </p>
            <div className="wrapper">
              <span className="span">Address:</span>
              <address className="address">ECR Banglore</address>
            </div>
            <div className="wrapper">
              <span className="span">Call:</span>
              <a href="" className="footer-link">
                +91 xxxxxxxxxx
              </a>
            </div>
            <div className="wrapper">
              <span className="span">Email:</span>
              <a href="mailto:vintogether.work@gmail.com" className="footer-link">
                vintogether.work@gmail.com
              </a>
            </div>
          </div>

          <ul className="footer-list">
            <li>
              <p className="footer-list-title">Online Platform</p>
            </li>
            <li>
              <a href="#about" className="footer-link">
                About
              </a>
            </li>
            <li>
              <a href="#courses" className="footer-link">
                Courses
              </a>
            </li>
          </ul>

          <ul className="footer-list">
            <li>
              <p className="footer-list-title">Links</p>
            </li>
            <li>
              <a href="#contact us" className="footer-link">
                Contact Us
              </a>
            </li>
            <li>
              <a href="#" className="footer-link">
                Gallery
              </a>
            </li>
            <li>
              <a href="#" className="footer-link">
                News & Articles
              </a>
            </li>
            <li>
              <a href="#" className="footer-link">
                FAQ's
              </a>
            </li>
            <li>
              <a href="#" className="footer-link">
                Sign In/Registration
              </a>
            </li>
            <li>
              <a href="#" className="footer-link">
                Coming Soon
              </a>
            </li>
          </ul>

          <div className="footer-list">
            <p className="footer-list-title">Leave a Review</p>
            <p className="footer-list-text">
              We value your feedback! Please let us know how we can improve.
            </p>
            <form onSubmit={handleSubmit} className="review-form">
              <textarea
                name="review"
                placeholder="Your review"
                required
                className="input-field"
                value={review}
                onChange={(e) => setReview(e.target.value)}
              ></textarea>
              <button type="submit" className="btn has-before">
                <span className="span">Submit Review</span>
              </button>
            </form>
                {message && <p className="message">{message}</p>}
  
            <br></br>
            <ul className="social-list">
              <li>
                <a href="#" className="social-link">
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
              </li>
              <li>
                <a href="#" className="social-link">
                  <FontAwesomeIcon icon={faLinkedinIn} />
                </a>
              </li>
             <li>
  <a
    href="https://www.instagram.com/vintogether/"
    className="social-link"
    target="_blank"
    rel="noopener noreferrer"
  >
    <FontAwesomeIcon icon={faInstagram} />
  </a>
</li>

              <li>
                <a href="#" className="social-link">
                  <FontAwesomeIcon icon={faTwitter} />
                </a>
              </li>
              <li>
                <a href="#" className="social-link">
                  <FontAwesomeIcon icon={faYoutube} />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p className="copyright">
            Copyright 2025 All Rights Reserved by
            <a href="#Home" className="copyright-link">
              VIN-Together
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
